export const customers = {
  title: '客户',
  resourceName: '客户',
  titles: {
    detail: '客户详情',
    view: '客户详情',
    show: '查看客户',
    edit: '编辑客户',
    create: '创建客户',
    list: '客户列表',
    addQuick: '快速添加',
  },
  messages: {
    noData: '暂无数据',
    totalCustomers: '共 {total} 个客户',
    savedSuccess: '保存成功',
    saving: '保存中...',
    updateSuccess: '客户更新成功',
    createSuccess: '客户创建成功',
    errorGeneric: '发生错误',
    loadDetailError: '无法加载客户详情',
  },
  validation: {
    codeNameRequired: '请输入客户代码和名称',
    emailInvalid: '邮箱格式无效',
    codeRequired: '请输入客户编号',
    nameRequired: '请输入客户名称',
  },
  status: {
    active: '启用',
    inactive: '停用',
    pending: '待处理',
  },
  gender: {
    male: '男',
    female: '女',
    other: '其他',
  },
  fields: {
    companyName: '公司',
    phoneNumber: '电话',
    id: 'ID',
    name: '名称',
    email: '邮箱',
    phone: '电话',
    address: '地址',
    area: '区域',
    status: '状态',
    isActive: '状态',
    createdAt: '创建时间',
    actions: '操作',
    fromWarehouse: '来源仓库',
    toWarehouse: '目标仓库',
    toWarehouseCode: '目标仓库代码',
    container: '容器',
    totalVolume: '总体积',
    totalWeight: '总重量',
    subCode: '子码',
    salesName: '销售',
    pricePerKg: '每公斤价格',
    pricePerM3: '每立方米价格',
    priceEachRow: '每行价格',
    entrustmentPercent: 'UTNK / 取税',
    code: '代码',
    getTax: '取税',
    codeLabel: '客户代码',
    nameLabel: '客户名称',
    updatedAt: '更新时间',
    notes: '备注',
  },
  tabs: {
    mapping: '副码',
  },
  searchByCode: {
    label: '只显示未链接的记录',
    placeholder: '按代码或名称搜索',
  },
  filter: {
    placeholder: '搜索客户',
    advancedFilter: '高级筛选',
    code: '客户代码',
    name: '客户名称',
    sales: '销售',
    allSales: '全部销售',
    clearFilter: '清除筛选',
    search: '搜索',
  },
  customerNotFound: '客户不存在',
  attachMainCode: '关联主码',
  import: {
    button: '导入',
    title: '导入客户',
    description: '选择 XLSX 文件（按照模板格式）。',
    noSheet: '在 Excel 文件中未找到工作表',
    readError: '读取 Excel 文件失败',
    noData: '没有可导入的数据',
    success: '成功导入 {count} 个客户',
    failed: '导入失败',
    savedSuccess: '保存成功',
    templateSheetName: '客户导入模板',
    templateFileName: '客户导入模板.xlsx',
    templateSuccess: '模板文件下载成功',
    templateFailed: '下载模板文件失败',
    templateLoading: '正在下载...',
    templateButton: '下载模板',
  },
  export: {
    button: '导出',
    loading: '正在导出...',
    success: 'Excel 文件导出成功',
    failed: '导出失败',
    fileName: '客户列表.xlsx',
    fileNameMapping: '副码列表.xlsx',
    sheetName: '客户列表',
    mappingSheetName: '副码列表',
  },
  mapping: {
    editTitle: '编辑副码',
    importSuccess: '副码导入成功',
    importLoading: '导入中...',
    importTitle: '导入副码',
    importDescription: '选择 XLSX 文件（按模板格式）。',
    templateSheetName: '副码导入模板',
    templateFileName: '副码导入模板.xlsx',
    templateSubCode: '副码',
    templateCustomerCode: '客户代码',
    templateWarehouseCode: '仓库代码',
    templatePriceEachRow: '每件价格',
    templatePricePerKg: '每公斤价格',
    templatePricePerM3: '每立方米价格',
    templateIsGetTax: '客户取税',
    templateEntrustmentPercent: '委托%',
  },
  form: {
    basicInfo: '基本信息',
    contactInfo: '联系信息',
    managerInfo: '负责人信息',
    servicePriceInfo: '服务与价格',
    otherInfo: '其他信息',
    isActiveLabel: '启用',
    noSelect: '不选',
    getTaxLabel: '索取发票',
    createdByPlaceholder: '创建人',
    introduceByPlaceholder: '介绍人',
    inChargeByPlaceholder: '负责人',
    areaPlaceholder: '区域',
    entrustmentPlaceholder: '委托百分比',
    priceEachRowPlaceholder: '每行价格',
    pricePerKgPlaceholder: '每公斤价格',
    pricePerM3Placeholder: '每立方米价格',
    genderLabel: '性别',
  },
}
